import { CHOOSABLE_SET_COMPARER_PRODUCT_ID } from '../action-types';

// @ts-expect-error - Automatic, Please fix when editing this file
const setChoosableComparerProductId = (productId) => (dispatch) =>
  dispatch({ comparerProductId: productId, type: CHOOSABLE_SET_COMPARER_PRODUCT_ID });

export default {
  setChoosableComparerProductId,
};
